export const ELASTIC_MAX_RESULTS = 10000 // limitation of ElasticSearch
